import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../api/auth";
import "./Login.css";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Attempt login
      const user = await login(username, password);

      // If login succeeds, user is already verified as Admin in auth.js
      console.log("Logged in Admin:", user);

      // Redirect to dashboard
      navigate("/dashboard");
    } catch (err) {
      // Display error (wrong credentials or non-Admin)
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="floating-bg floating-bg-1"></div>
      <div className="floating-bg floating-bg-2"></div>
      <div className="floating-bg floating-bg-3"></div>

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-header">
          <h2>Welcome Back</h2>
          <p>Sign in to your warehouse account</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="input-group">
          <input
            type="text"
            className="glass-input"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div className="input-group">
          <input
            type="password"
            className="glass-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <button
          type="submit"
          className="glass-btn login-btn"
          disabled={loading}
        >
          {loading ? "Signing In..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default Login;
